import axios from "axios";
import Base from "./base";

class Projects extends Base {}

class Project extends Base {
  constructor() {
    super();
    this.company = {};
  }
}

const project = new Project();

const state = {
  projects: new Projects(),
  project,
};

const getters = {
  projects: (state) => state.projects,
  project: (state) => state.project,
};

const actions = {
  async fetchProjects({ commit, state }) {
    commit("setLoadingProjects", true);
    const res = await axios.get("https://agungsepruloh.herokuapp.com/projects");
    commit("setLoadingProjects", false);
    commit("setProjects", res.data);
  },
  async fetchProject({ commit }, id) {
    commit("setLoadingProject", true);
    const res = await axios.get(
      `https://agungsepruloh.herokuapp.com/projects/${id}`
    );
    commit("setLoadingProject", false);
    commit("setProject", res.data);
  },
  async clearProject({ commit }) {
    commit("setProject", project);
  },
};

const mutations = {
  setProjects: (state, projects) => (state.projects = projects),
  setLoadingProjects: (state, value) => (state.projects.isLoading = value),
  setProject: (state, project) => (state.project = project),
  setLoadingProject: (state, value) => (state.project.isLoading = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
